export const routes = {
  login: "/login",

  task: {
    root: "/",
    create: "/work-orders/new",
    byId: (id: number | string) => `/tasks/${id}`,
    byUser: "/tasks",
    detail: (workOrderId: string) => `/work-orders/${workOrderId}`,
  },
  calendar: {
    root: "/kalendar",
  },
  zeitmanagement: {
    root: "/zeitmanagement",
    create: "/zeitmanagement/new",
    edit: (id: string | number) => `/zeitmanagement/${id}/edit`,
  },
  aufgaben: {
    root: "/aufgaben",
    create: "/aufgaben/new",
    edit: (id: string | number) => `/aufgaben/${id}/edit`,
    plan: "/aufgaben/plan",
  },
  reschedule: {
    root: "/reschedule",
  },
  admin: {
    root: "/admin",
    mailSettings: "/admin/mail-settings",
  },

  users: {
    root: "/users",
    create: "/users/new",
    edit: (id: string | number) => `/users/${id}/edit`,
  },

  disposition: {
    root: "/disposition",
  },

  auth: {
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },

  workerZeitmanagement: {
    edit: (id: string | number) => `/worker/zeitmanagement/${id}/edit`,
  },

  worker: {
    calendar: '/worker/calendar',
    privatzeit: '/worker/privatzeit',
    appointment: (id: string | number) => `/worker/appointments/${id}`,
    task: (id: string | number) => `/worker/tasks/${id}`,
  },

  controlling: {
    root: '/controlling',
  },
};
